export enum HashValues {
  VERIFY_EMAIL = 'verify-email',
  RESET_PASSWORD = 'reset-password',
}
